import { useCart } from '@/data/Content/Cart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Box, Typography } from '@mui/material';

export const FreeShipping = () => {
	const { data } = useCart();

	if (data?.totalShippingCharge === '0.00000') {
		return null;
	}
	return (
		<Box sx={{ display: 'grid', placeItems: 'center' }}>
			<Box
				sx={{
					display: 'flex',
					gap: '5.3px',
					alignItems: 'center',
					bgcolor: '#F4F4F4',
					p: '5px 11px',
					borderRadius: '15px',
					width: 'fit-content',
					mt: '6px',
				}}
			>
				<LocalShippingIcon sx={{ color: '#0E8439', width: '20px', height: '16px' }} />
				<Typography component={'p'} sx={{ fontSize: '13px' }}>
					{'Añade '}
					<Box component={'span'} sx={{ fontWeight: 'bold' }}>
						{`  $${
							data?.grandTotal
								? data.totalShippingCharge
									? (999 - Number(data?.grandTotal) + 100).toFixed(2)
									: (999 - Number(data?.grandTotal)).toFixed(2)
								: 999
						}`}{' '}
					</Box>
					{' para conseguir '}
					<Box component={'span'} sx={{ fontWeight: 'bold', color: '#0E8439' }}>
						{'envío gratis'}
					</Box>
				</Typography>
			</Box>
		</Box>
	);
};
